import React, { Component } from 'react';
import { connect } from 'react-redux';
import { searchChess, updateChessState, loadChess, setCells,
  loadPavilions } from 'actions/building';
import debounce from 'lodash.debounce';
import interiors from 'constants/interiors';
import { pluralize, parseQuery, compileQuery, formatNumber } from 'utils';
import groupBy from 'lodash.groupby';

import Filters from './Filters';
import SubFilters from './SubFilters';
import Flats from './Flats';
import nothingFound from 'assets/images/nothingfound.png';
import s from './styles.scss';
import cn from 'classnames';
import intersection from 'lodash.intersection';
import apartments from 'constants/apartments';
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { getLotsType } from '../Building/Main/helper';
import get from 'lodash.get';
import { isReserved } from '../../helper';

const sorts = {
  'priceAll ASC': {
    text: i18n.t('components.flatsList.flatsList.sorts.priceAllAsc'),
    orderField: 'price_all',
    orderDirection: 'ASC',
    key: 'priceAllAsc'
  },
  'priceAll DESC': {
    text: i18n.t('components.flatsList.flatsList.sorts.priceAllDesc'),
    orderField: 'price_all',
    orderDirection: 'DESC',
    key: 'priceAllDesc'
  },
  'area ASC': {
    text: i18n.t('components.flatsList.flatsList.sorts.priceAllAsc'),
    orderField: 'area_all',
    orderDirection: 'ASC',
    key: 'areaAsc'
  },
  'area DESC': {
    text: i18n.t('components.flatsList.flatsList.sorts.priceAllAsc'),
    orderField: 'area_all',
    orderDirection: 'DESC',
    key: 'areaDesc'
  }
};
const sortKeys = Object.keys(sorts);
const initState = {
  priceFrom: 0,
  priceTo: 0,
  areaFrom: 0,
  areaTo: 0,
  interior: 'all'
};
class FlatsList extends Component {
  constructor(props) {
    super(props);
    this.searchChess = debounce(this.searchChess, 500).bind(this);
    this.state = {
      ...initState,
      sort: 'priceAll ASC',
      active: null,
      isFirstTimeFetching: true,
      defaultTotal: 0
    };
  }

  componentDidMount() {
    this.searchChess();
    this.prepareChess(this.props, true);
    this.pavilions = groupBy(
      this.props.building.data.pavilions,
      'id'
    );
    loadPavilions(this.props.building.data.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.prepareChess(nextProps);
  }

  parseQuery = (query) => {
    if (this.props.print) {
      return this.props.queryParams || {};
    }
    const {
      section, table, sort, cell,
      priceMin, priceMax, costMin, costMax,
      areaFrom, areaTo, interior, view_type
    } = parseQuery(query);
    const selectedSectionKey = section || null;
    const selectedSectionPath = selectedSectionKey ? selectedSectionKey.split('.').map((value) => Number(value)) : null;
    let isTable,
      isExtended;
    switch (table) {
      case 'common':
        isTable = true; isExtended = false; break;
      case 'extended':
        isTable = true; isExtended = true; break;
      case 'list':
        isTable = false; isExtended = false; break;
      default:
        isTable = null; isExtended = null;
    }
    let listSortPath = null;
    if (sort) {
      const [column, direction] = sort.split(':');
      listSortPath = [column, direction !== 'desc'];
    }
    const selectedCelllPath = cell ? cell.split('.').map((value) => Number(value)) : null;

    const { buildingForGallery: {
      isTable: prevIsTable,
      isExtended: prevIsExtended,
      selected: prevSelected,
      filters: prevFilters,
      filters: {
        section: prevSelectedSectionPath
      },
      listSort: prevListSort
    } } = this.props;
    const prevSelectedSectionKey = prevSelectedSectionPath.join('.');

    return {
      isTable: this.props.client ? false : (isTable != null ? isTable : prevIsTable),
      isExtended: isExtended != null ? isExtended : prevIsExtended,
      selected: selectedCelllPath != null
        ? { ...prevSelected, [selectedSectionKey != null ? selectedSectionKey : prevSelectedSectionKey]: selectedCelllPath }
        : prevSelected,
      filters: {
        ...prevFilters,
        section: selectedSectionPath != null ? selectedSectionPath : prevSelectedSectionPath,
        priceMin,
        priceMax,
        costMin,
        costMax,
        areaFrom,
        areaTo,
        interior,
        view_type
      },
      listSort: listSortPath != null ? listSortPath : prevListSort
    };
  }

  prepareChess = (props, initial = false) => {
    if (!props.buildingForGallery.isLoading) {
      const { pavilions } = props.buildingForGallery;
      const { location } = props;
      const { location: prevLocation } = this.props;
      if (location !== prevLocation) {
        const { updateChessState } = this.props;
        const params = this.parseQuery(location.search);
        updateChessState(params);
        return;
      }

      if (pavilions) {
        const { buildingForGallery: { chessList, filters: { section: selectedSectionPath } } } = props;

        const selectedSectionKey = selectedSectionPath.join('.');
        const [pavilionId, sectionId] = selectedSectionPath;
        const selectedSectionId = pavilions[pavilionId].sections[sectionId].id;
        const chess = chessList[selectedSectionId];
        const filtersChanged = JSON.stringify(this.props.buildingForGallery.filters) !== JSON.stringify(props.buildingForGallery.filters);
        const { isChessLoading } = props.buildingForGallery;
        if (!isChessLoading || filtersChanged) {
          const { loadChess } = props;
          const updateCells = (resp) => {
            const { setCells } = props;
            let { rows, cols, cells } = resp.data.data;
            rows = rows || []; cols = cols || []; cells = cells || [];
            const { data, selected } = this.getData(rows, cols, cells);
            setCells(selectedSectionKey, data, selected);
          };

          let filteredIntersection = null;
          // FIXME: убрать это и вынести отсюда
          if (chess) {
            const interiorsInHouse = chess.cells.reduce(
              (list, cell) => {
                if (cell.data.status === 'saleStatus' || isReserved(cell.data.status) || cell.data.status === 'assignmentStatus') {
                  return list.includes(cell.data.interior) ? list : [cell.data.interior, ...list];
                }
                return list;
              },
              ([])
            );
            const splitedInterior = props.buildingForGallery.filters.interior && props.buildingForGallery.filters.interior.length ? props.buildingForGallery.filters.interior.split(',') : [];
            const interiorIntersection = intersection(interiorsInHouse, splitedInterior);
            filteredIntersection = interiorIntersection.length ? interiorIntersection.join(',') : null;
          }

          if (initial || !chess || filtersChanged || this.filteredIntersection !== filteredIntersection) {
            this.filteredIntersection = filteredIntersection;
            loadChess({
              id: selectedSectionId,
              costMin: props.buildingForGallery.filters.costMin,
              costMax: props.buildingForGallery.filters.costMax,
              areaFrom: props.buildingForGallery.filters.areaFrom,
              areaTo: props.buildingForGallery.filters.areaTo,
              stock: filteredIntersection
            }).then(updateCells);
          }
        }
      }
    }
  }

  getData = (rows, cols, cells) => {
    const rowLength = rows.length;
    const colLength = cols.reduce((prev, cur) => (prev + (Number(cur.colspan) || 1)), 0);
    const data = Array(rowLength).fill(null).map(() => ({ cells: Array(colLength) }));

    let selected,
      imagelessSelected,
      soldSelected;

    cells.forEach((cell, index) => {
      let { row, col, rowspan, colspan } = cell;

      row = Number(row);
      col = Number(col);

      if (row > rowLength - 1 || col > colLength - 1) {
        throw new Error(`Ячейка под индексом ${index} ссылается на неизвестный row или col`);
        // return;
      }
      if (data[row].cells[col] !== undefined) {
        return;
      }

      colspan = !colspan || colspan === '0' ? 1 : Number(colspan);
      rowspan = !rowspan || rowspan === '0' ? 1 : Number(rowspan);

      if (rowspan > 1 || colspan > 1) {
        for (let rowKey = row; rowKey < row + rowspan; ++rowKey) {
          if (rowKey > rowLength - 1) {
            throw new Error(`Ячейка под индексом ${index} слишком высокая и выходит за пределы таблицы`);
          }
          for (let colKey = col; colKey < col + colspan; ++colKey) {
            if (colKey > colLength - 1) {
              throw new Error(`Ячейка под индексом ${index} слишком широкая и выходит за пределы таблицы`);
            }
            data[rowKey].cells[colKey] = null;
          }
        }
      }

      if (cell.data.disabled) {
        data[row].cells[col] = null;
        return;
      }

      const floorName = rows[cell.row].name;
      const interiorName = interiors[cell.data.interior];
      const apartmentsName = apartments[cell.data.cnt_apart];
      const priceFormatted = formatNumber(cell.data.priceM);
      const costFormatted = formatNumber(cell.data.priceAll);
      const hidden = ['soldStatus', '0'].includes(cell.data.status) || (!cell.data.area && !['fundStatus'].includes(cell.data.status));

      const room = {
        ...cell,
        data: { ...cell.data, interiorName, floorName, apartmentsName, priceFormatted, costFormatted },
        row,
        col,
        rowspan,
        colspan,
        hidden
      };
      room.content = {
        common: hidden ? null : this.getCellContent(room),
        extended: hidden ? null : this.getCellExtendedContent(room)
      };

      data[row].cells[col] = room;

      if (!selected) {
        if (room.planId && !room.hidden) {
          selected = [row, col];
        } else if (!imagelessSelected) {
          if (!room.hidden) {
            imagelessSelected = [row, col];
          } else if (!soldSelected) {
            soldSelected = [row, col];
          }
        }
      }
    });

    return { data, selected: selected || imagelessSelected || soldSelected || null };
  }

  getCellContent(room) {
    return room.data.area;
  }

  getCellExtendedContent = (room) => {
    const { t } = this.props;

    const reservation = isReserved(room.data.status);
    if (this.props.print) {
      return (
        <div className={cn(s.ExtendedContent, { [s.Reservation]: reservation }, s.ExtendedContentPrint)}>
          <div className={s.ExtendedContentLeft}>
            <p><span className={s.PrintExtendedEmptySpan}></span></p>
            <p><span>{room.data.area}</span></p>
          </div>
          <div className={s.ExtendedContentRight}>
            <p><span>{room.data.costFormatted}</span></p>
            <p><span>{room.data.priceFormatted}</span></p>
          </div>
        </div>
      );
    }
    return (
      <div className={cn(s.ExtendedContent, { [s.Reservation]: reservation }, { [s.NotMatch]: !room.mark })}>
        <div className={s.ExtendedContentLeft}>
          <p><span className={s.ExtendedFlatNum}>{`№${room.data.number}`}</span></p>
          {room.data.apartmentsName ? (
            <p><span>{room.data.apartmentsName}</span></p>
            ) : null}

          {/* <p><span>{room.data.area}</span></p> */}
        </div>
        <div className={s.ExtendedContentRight}>
          {/* <p><span>{room.data.interiorName}</span></p> */}
          {(room.data.costFormatted && (room.data.costFormatted == 0)) ? null : (
            <p><span className={s.ExtendedFlatPrice}>{room.data.costFormatted}</span></p>
            )}
          <p>
            <span>
              {t('components.flatsList.flatsList.area', { area: room.data.area })}
              {(room.data.priceFormatted == 0) ? null : (
                <span className={s.Span}>
                      , {t('components.flatsList.flatsList.price', { price: room.data.priceFormatted })}
                </span>
                )}
            </span>
          </p>
        </div>
      </div>
    );
  }

  searchChess = (params = {}) => {
    const filter = {
      offset: 0,
      limit: 10,
      buildingId: ~~this.props.building.data.id,
      userUid: this.props.userUid,
      priceFrom: this.state.priceFrom,
      priceTo: this.state.priceTo,
      areaFrom: this.state.areaFrom,
      areaTo: this.state.areaTo,
      interior: this.state.interior === 'all' ? [] : [this.state.interior],
      pavilionId: this.state.pavilion,
      orderField: sorts[this.state.sort].orderField,
      orderDirection: sorts[this.state.sort].orderDirection,
      ...params
    };

    const chessIds = this.props.building.data.chessIds || [];

    if (getLotsType() === 1) {
      filter.ids = chessIds.length ? chessIds : [-1];
      filter.limit = chessIds.length;
    }

    this.props.searchChess(filter).then(response => {
      this.setDefaultTotalFlats(response.response.data.data.total);
    });
  }

  setDefaultTotalFlats(total) {
    if (this.state.isFirstTimeFetching) {
      this.setState({ isFirstTimeFetching: false });
      this.setState({ defaultTotal: total });
    }
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value
      }, this.searchChess
    );
  }

  handleDropdownClick = (interior) => {
    this.setState(
      {
        interior
      }, this.searchChess
    );
  }

  handlePavilionChange = (id) => {
    this.setState(
      {
        pavilion: id
      }, this.searchChess
    );
  }

  handleSortChange = (sort) => {
    this.setState({ sort }, this.searchChess);
  }

  handleMoreClick = () => {
    if (!this.props.loading && !this.props.finished) {
      this.searchChess({ offset: this.props.offset });
    }
  }

  handleFlatClick = (flatId) => {
    this.setState({
      active: this.state.active === flatId ? null : flatId
    });
  }
  startNewSearch = () => {
    this.setState({ ...this.state, ...initState }, () => this.searchChess());
  }

  render() {
    const { data, total, finished, selection: { showInfo }, building, buildingForGallery, t } = this.props;
    const {
      priceTo,
      priceFrom,
      areaFrom,
      areaTo,
      interior,
      sort,
      active,
      defaultTotal
    } = this.state;
    const isFlatsExistsByDefalut = defaultTotal > 0;
    const isFlatsExists = total > 0;

    if (!isFlatsExistsByDefalut && !isFlatsExists && getLotsType() === 1) {
      return null;
    }

    if (data) {
      return (
        <div className={s.FlatsWrapper}>
          <div className={s.FlatsTitle}>
            <p>{pluralize(total, t('components.flatsList.flatsList.flat1'), t('components.flatsList.flatsList.flat2'), t('components.flatsList.flatsList.flat3'))} ({total})</p>
          </div>
          {isFlatsExistsByDefalut &&
            <Filters
              priceFrom={priceFrom}
              priceTo={priceTo}
              areaFrom={areaFrom}
              areaTo={areaTo}
              handleChange={this.handleChange}
              handleDropdownClick={this.handleDropdownClick}
              handlePavilionChange={this.handlePavilionChange}
              interiors={interiors}
              interior={interior}
              pavilions={building.data.pavilions}
              pavilion={this.state.pavilion}
            />
          }
          <div className={s.FlatsListWrap}>
            {isFlatsExistsByDefalut &&
              <SubFilters
                sorts={sorts}
                sortKeys={sortKeys}
                sort={sort}
                total={total}
                handleSortChange={this.handleSortChange}
              />
            }
            {isFlatsExistsByDefalut ?
              isFlatsExists ?
                <Flats
                  finished={finished}
                  data={data}
                  active={active}
                  handleMoreClick={this.handleMoreClick}
                  handleFlatClick={this.handleFlatClick}
                  pavilions={this.pavilions}
                  building={building.data}
                  showInfo={showInfo}
                  buildingForGallery={buildingForGallery}
                />
                :
                <div className={cn(s.badMessageContainer, s.alignTop)}>
                  <div className={s.badMessageLeft}>
                    <div className={s.badMessageTitle}>
                      {t('components.flatsList.flatsList.notFound')}
                    </div>
                    <button onClick={this.startNewSearch} className={s.badMessageBtn}>
                      {t('components.flatsList.flatsList.startNewSearch')}
                    </button>
                  </div>
                  <img src={nothingFound} className={s.badMessageImage} alt={t('components.flatsList.flatsList.soldOut')} />
                </div>
              :
                <div className={s.badMessageContainer}>
                  <div className={s.badMessageLeft}>
                    <div className={s.badMessageTitle}>
                      {t('components.flatsList.flatsList.noForSale')}
                    </div>
                    <div className={s.badMessageSubtitle}>
                      {building.data.type_id == 2 ? t('components.flatsList.flatsList.soldAllHouses') : t('components.flatsList.flatsList.soldAllFlats')}
                    </div>
                  </div>
                  <img src={nothingFound} className={s.badMessageImage} alt={t('components.flatsList.flatsList.soldOut')} />
                </div>
            }
          </div>
        </div>
      );
    }
    return null;
  }
}

export default connect(
  state => state.flats,
  { searchChess, updateChessState, loadChess, setCells, loadPavilions }
)(withTranslation()(FlatsList));



// WEBPACK FOOTER //
// ./src/components/FlatsList/FlatsList.js